import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../utils/csrf"
import { refreshPins } from "../utils/refresh_pins"

// Rename / delete controls on a folder card's header (edit-pinned screen).
// Rename swaps the title for an inline input (PATCH /pins/:id); delete confirms
// then DELETEs (server promotes the folder's children back into the list) and
// reloads so the new order renders server-side.
export default class extends Controller {
    static values = { url: String }
    static targets = ["title", "input", "cardTitle"]

    edit(event) {
        event?.preventDefault()
        this.titleTarget.classList.add("hidden")
        this.inputTarget.classList.remove("hidden")
        this.inputTarget.focus()
        this.inputTarget.select()
    }

    cancel(event) {
        event?.preventDefault()
        this.inputTarget.value = this.titleTarget.textContent.trim()
        this._closeInput()
    }

    save(event) {
        event?.preventDefault()
        const name = this.inputTarget.value.trim()
        const current = this.titleTarget.textContent.trim()
        this._closeInput()
        if (!name || name === current) {
            this.inputTarget.value = current
            return
        }
        fetch(this.urlValue, {
            method: "PATCH",
            headers: { Accept: "application/json", "Content-Type": "application/json", "X-CSRF-Token": csrfToken() },
            credentials: "same-origin",
            body: JSON.stringify({ name })
        })
            .then((response) => response.json())
            .then((data) => {
                if (!data.ok) return
                this.titleTarget.textContent = data.name
                if (this.hasCardTitleTarget) this.cardTitleTarget.textContent = data.name
            })
            .catch(() => {})
    }

    remove(event) {
        event?.preventDefault()
        if (!window.confirm("Delete this folder? Its pins move up a level.")) return
        fetch(this.urlValue, {
            method: "DELETE",
            headers: { Accept: "application/json", "X-CSRF-Token": csrfToken() },
            credentials: "same-origin"
        })
            .then((response) => { if (response.ok) refreshPins(this.element) })
            .catch(() => {})
    }

    // The folder's icon, from the emoji picker in its head; an empty one clears
    // it. The editor refreshes in place so the folder's row shows it too.
    setEmoji(event) {
        const emoji = event.detail?.emoji
        if (emoji) this._saveEmoji(emoji)
    }

    clearEmoji(event) {
        event?.preventDefault()
        this._saveEmoji("")
    }

    _saveEmoji(emoji) {
        fetch(this.urlValue, {
            method: "PATCH",
            headers: { Accept: "application/json", "Content-Type": "application/json", "X-CSRF-Token": csrfToken() },
            credentials: "same-origin",
            body: JSON.stringify({ metadata: { emoji } })
        })
            .then((response) => { if (response.ok) refreshPins(this.element) })
            .catch(() => {})
    }

    _closeInput() {
        this.inputTarget.classList.add("hidden")
        this.titleTarget.classList.remove("hidden")
    }
}
